
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.938 4.75l.75 4.25h-2.031l-.344-1.938L15 9H3.156zM2 10h28v16H2V10zm4.938 2c.033.163.063.327.063.5a2.5 2.5 0 01-2.5 2.5c-.173 0-.337-.029-.5-.063v6.125c.163-.033.327-.063.5-.063a2.5 2.5 0 012.5 2.5c0 .173-.029.337-.063.5h18.125a2.497 2.497 0 01-.063-.5 2.5 2.5 0 012.5-2.5c.173 0 .337.029.5.063v-6.125a2.497 2.497 0 01-.5.063 2.5 2.5 0 01-2.5-2.5c0-.173.029-.337.063-.5H6.938zM16 13c2.75 0 5 2.25 5 5s-2.25 5-5 5-5-2.25-5-5 2.25-5 5-5zm0 2c-1.669 0-3 1.331-3 3s1.331 3 3 3 3-1.331 3-3-1.331-3-3-3z"}})])
          )
        }
      }
    